import { GoldState } from '../../models/game-model';
import { AssetManager, SpineExtended, container } from '@game-studio/arcade-base';
import { ISkeletonData, Spine } from 'pixi-spine';
import { Container } from 'pixi.js-legacy';
import { gameModel } from '../../models/game-model';
import { CollectorState, collectorService } from '../../services/collector-service';
import { gameEventEmitter } from '@/src/events';
import { collectorKey } from './collector/collector-view';

export class BackgroundView extends Container {
    private _backgroundSpine: SpineExtended;
    private _winStates: CollectorState[];

    constructor() {
        super();
        // Create spine asset.
        const spineData: ISkeletonData = AssetManager.getSpineResourceData('background');
        this._backgroundSpine = new SpineExtended(spineData);
        this.addChild(this._backgroundSpine);

        // Setup winStates.
        this._winStates = new Array(gameModel.collectorStates.length).fill(CollectorState.Available);

        // Add bindings and listeners.
        this.addListeners();
    }

    public start(): void {
        // Play spine intro and control purchase state.
        this._backgroundSpine.setAnimationPromise('intro').then(() => {
            container.cabinet.enablePurchaseButton();
            container.cabinet.updateStakeButtons();
            this._backgroundSpine.state.setAnimation(0, 'loop', true);
        });
    }

    public get spine(): Spine {
        return this._backgroundSpine;
    }

    private onWin$(): void {
        for (let $collectorIndex = 0; $collectorIndex < gameModel.collectorStates.length; $collectorIndex++) {
            const collectorPanelState = gameModel.collectorStates[$collectorIndex];
            if (this._winStates[$collectorIndex] === CollectorState.Available && collectorService.isWin(collectorPanelState)) {
                this._winStates[$collectorIndex] = CollectorState.Allocated;

                // Prevent win animation during a gold prize.
                if (gameModel.goldState !== GoldState.IDLE) {
                    return;
                }

                // Play formated win animation.
                const winAnimation: string = 'win/win' + collectorKey[$collectorIndex].charAt(0).toUpperCase() + collectorKey[$collectorIndex].slice(1);
                this._backgroundSpine.state.setAnimation(1, winAnimation, false);
            }
        }
    }

    private onGoldState$(): void {
        if (gameModel.goldState === GoldState.TRANS_ON) {
            this._backgroundSpine.setAnimationPromise('goldenOn').then(() => {
                this._backgroundSpine.state.setAnimation(0, 'goldLoop', true);
            });
        }

        if (gameModel.goldState === GoldState.COMPLETE) {
            this._backgroundSpine.setAnimationPromise('goldenOff').then(() => {
                this._backgroundSpine.state.setAnimation(0, 'loop', true);
                gameModel.goldState = GoldState.IDLE;
            });
        }
    }

    private onNewGame$(): void {
        this._winStates = new Array(gameModel.collectorStates.length).fill(CollectorState.Available);
    }

    private addListeners(): void {
        gameEventEmitter.on('NEW_GAME', this.onNewGame$.bind(this));
        gameModel.bindToValue(
            this,
            () => gameModel.goldState,
            () => this.onGoldState$
        );
        gameModel.bindToValue(
            this,
            () => gameModel.collectorStates,
            () => this.onWin$
        );
    }
}
